"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestOrderType = exports.OrderVariantType = exports.OrderAmountType = void 0;
/** 订购数量类型 */
var OrderAmountType;
(function (OrderAmountType) {
    OrderAmountType["Stock"] = "STOCK";
    OrderAmountType["Time"] = "TIME";
    OrderAmountType["Zero"] = "ZERO";
})(OrderAmountType || (exports.OrderAmountType = OrderAmountType = {}));
/** 订购物品类型 */
var OrderVariantType;
(function (OrderVariantType) {
    OrderVariantType["Inout"] = "INOUT";
    OrderVariantType["ItemSearchTemplate"] = "ITEM_SEARCH_TEMPLATE";
    OrderVariantType["ItemType"] = "ITEM_TYPE";
    OrderVariantType["Location"] = "LOCATION";
    OrderVariantType["RequestTemplate"] = "REQUEST_TEMPLATE";
    OrderVariantType["UnSupplied"] = "UN_SUPPLIED";
})(OrderVariantType || (exports.OrderVariantType = OrderVariantType = {}));
/** 要货单类型 */
var RequestOrderType;
(function (RequestOrderType) {
    RequestOrderType["ItemType"] = "ITEM_TYPE";
    RequestOrderType["Location"] = "LOCATION";
})(RequestOrderType || (exports.RequestOrderType = RequestOrderType = {}));
